import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { Link } from "@/components/catalyst/link";
import { userRecordQuery } from "@/app/Users/GraphQL/userRecordQuery";
import { UserListItem, userListQuery } from "@/app/Users/GraphQL/userListQuery";

export function UserInput({
  excludeIds,
  ...props
}: BaseComboboxInputProps<
  ResultOf<typeof userListQuery>,
  VariablesOf<typeof userListQuery>,
  UserListItem,
  any
> & { excludeIds?: string[] }) {
  return (
    <ComboboxInput
      document={userListQuery}
      accessor={(data) => data.users.data}
      getQueryVariables={(search) => ({
        first: 20,
        page: 1,
        search: search ? search : undefined,
        excludeIds,
      })}
      recordDocument={userRecordQuery}
      recordAccessor={(data) => data.user!}
      getViewNode={(item) =>
        item ? (
          <Link
            className="text-blue-500"
            from="/$tenant/$orgId/supplier/{-$supplierId}"
            to="/$tenant/$orgId/supplier/{-$supplierId}/users/$id"
            params={(prev) => ({
              ...prev,
              id: item.id,
            })}
          >
            {item.name}
          </Link>
        ) : null
      }
      getKey={(i) => i.id}
      getListItemNode={(i) => (
        <div>
          <p>{i.name}</p>
          <p className="text-xs text-gray-500">{i.primary_email}</p>
        </div>
      )}
      getInputNode={(i) => i.name}
      {...props}
    />
  );
}
